import { render, staticRenderFns } from "./StaffNew.vue?vue&type=template&id=694f554e&scoped=true&"
import script from "./StaffNew.vue?vue&type=script&lang=js&"
export * from "./StaffNew.vue?vue&type=script&lang=js&"
import style0 from "./StaffNew.vue?vue&type=style&index=0&id=694f554e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694f554e",
  null
  
)

export default component.exports